import { isPlatformBrowser, NgClass } from '@angular/common';
import {
  Component,
  computed,
  Inject,
  inject,
  Input,
  OnInit,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import { NgbDropdownModule, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { Leads } from '../../services/leads';
import { LocalStorageService } from '../../services/common/localstorage-service';
import { Router, RouterLink } from '@angular/router';
import { RvsfInitService } from 'src/core/services/common/rvsf-init-service';
import { Rvsf } from 'src/core/services/rvsf';
import { NotificationOffcanvas } from '../ui/notification-offcanvas/notification-offcanvas';
import { NotificationService } from 'src/core/services/notification.service';
import { AuthService } from 'src/core/services/auth-service';

@Component({
  selector: 'app-header',
  imports: [NgClass, NgbDropdownModule, RouterLink],
  templateUrl: './header.html',
  host: { ngSkipHydration: '' },
  styles: ``,
})
export class Header implements OnInit {
  @Input() type: 'default' | 'dashboard' = 'default';

  private notificationService = inject(NotificationService);
  private authService = inject(AuthService);
  unreadCount = computed(() => this.notificationService.unreadCount());

  rvsfDetails = computed(() => this.rvsfInitService.config()());

  branchList = signal<any[]>([]);
  selectedBranch: any;
  user: any = null;

  isMobileSearch: boolean = false;
  isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private leadService: Leads,
    private localStorageService: LocalStorageService,
    private rvsfInitService: RvsfInitService,
    private rvsfService: Rvsf,
    private router: Router,
    private offcanvasService: NgbOffcanvas,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  // ngOnInit() {
  //   if (this.isBrowser) {
  //     this.loadBranches();
  //     this.selectedBranch = this.localStorageService.get('branch');
  //     this.user = this.localStorageService.get('user');
  //   }
  // }
  ngOnInit() {
    if (this.isBrowser) {
      this.user = this.localStorageService.get('user');
      const token = this.localStorageService.get('token');

      if (this.user && token) {
        this.notificationService.getUnreadCount().subscribe();
      }

      if (this.user?.branches?.length) {
        this.branchList.set(this.user.branches);
        this.selectedBranch = this.localStorageService.get('branch');

        // if (!this.selectedBranch) {
        //   this.setSelectedBranch(this.branchList()[0]);
        // }
        let isValidBranch = false;
        if (this.selectedBranch) {
          isValidBranch = !!this.branchList().find(
            (b: any) => b.branch_id === this.selectedBranch.branch_id,
          );
        }

        if (!this.selectedBranch || !isValidBranch) {
          this.setSelectedBranch(this.branchList()[0]);
        } else {
          this.selectedBranch = this.branchList().find(
            (b: any) => b.branch_id === this.selectedBranch.branch_id,
          );
        }
      }
    }
  }

  // loadBranches() {
  //   this.leadService.getBranchesByRvsf().subscribe({
  //     next: (res: any) => {
  //       this.branchList.set(res.data || []);
  //       if (!this.selectedBranch) {
  //         this.setSelectedBranch(this.branchList()[0]);
  //       }
  //     },
  //     error: (err) => {},
  //   });
  // }

  setSelectedBranch(branch: any) {
    this.selectedBranch = branch;
    this.localStorageService.set('branch', branch);

    window.location.reload();
  }

  get userAvatar(): string {
    const path = this.user?.profile_picture_path;
    if (!path) return '/hero/d-img.jpg';
    return path;
  }

  openNotifications() {
    this.offcanvasService.open(NotificationOffcanvas, {
      position: 'end',
      panelClass: 'notification-offcanvas-panel',
    });
  }

  logout() {
    this.rvsfService.userLogout().subscribe({
      next: () => {
        this.authService.logout();
        this.router.navigate(['/login']);
      },
      error: () => {
        this.authService.logout();
        this.router.navigate(['/login']);
      },
    });
  }
}
